import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { login as firebaseLogin } from './services/authService';
import { signInWithGoogle } from './services/authService';
function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // Call Firebase Auth wrapper
      const data = await firebaseLogin(email, password); // { id, name, email }

      setLoading(false);
      // Update AuthContext
      login(data);
      // Navigate like before
      navigate(`/main/${data.name}`);
    } catch (err) {
      console.error('Firebase login error:', err);
      setLoading(false);
      setError(err.message || 'Login failed');
    }
  };
const handleGoogleSignIn = async () => {
    setError('');
    setLoading(true);

    try {
      // THIS FUNCTION HANDLES BOTH LOGIN AND FIRST-TIME SIGNUP
      const data = await signInWithGoogle(); 
      
      login(data); // Update AuthContext state
      navigate(`/main/${data.name}`); // Redirect upon success

    } catch (err) {
      console.error('Google Sign-In error:', err);
      setLoading(false);
      setError(err.message || 'Google Sign-In failed.');
    }
  };

  return (
    <div className="auth-bg">
      <div className="auth-card-neon">
        <h2 className="auth-title">Welcome back</h2>
        {error && <div className="auth-error">{error}</div>}
        <button 
  type="button"
  onClick={handleGoogleSignIn} 
 style={{alignContent: 'center',marginLeft: '90px',marginBottom: '30px'}}
  disabled={loading}
>
    <div className="auth-switch-link">Log in with Google</div>
</button>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-input-group">
            <span className="auth-input-icon">📧</span>
            <input className="auth-input" type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
          </div>
          <div className="auth-input-group">
            <span className="auth-input-icon">🔒</span>
            <input className="auth-input" type={showPassword ? 'text' : 'password'} placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
            <span className="auth-input-icon auth-eye" onClick={() => setShowPassword(v => !v)} style={{ cursor: 'pointer' }}>{showPassword ? '🙈' : '👁️'}</span>
          </div>
          <button className="auth-btn" type="submit" disabled={loading}>{loading ? 'Logging in...' : 'Login'}</button>
        </form>
        <div className="auth-switch-text">
          Don&apos;t have an account?{' '}
          <a href="/signup" className="auth-switch-link">Sign up</a>
        </div>
      </div>
    </div>
  );
}
export default Login;